import { ItemStatus } from "../types/admin";

/**
 * Get a color for an item status based on its color field or name-based fallback.
 */
export const getItemStatusColor = (status: ItemStatus): string => {
  if (status.color && status.color.startsWith("#")) {
    return status.color;
  }
  const statusName = status.name.toLowerCase();
  if (statusName.includes("pending")) return "#ff9800";
  if (statusName.includes("processing")) return "#2196f3";
  if (statusName.includes("ordered")) return "#4caf50";
  if (statusName.includes("shipped")) return "#9c27b0";
  if (statusName.includes("delivered")) return "#4caf50";
  if (statusName.includes("cancelled")) return "#f44336";
  if (statusName.includes("hold")) return "#ff9800";
  return "#757575";
};

/**
 * Get a MUI Chip color for a status string name.
 * Used across order tables and modals for consistent status chip coloring.
 */
type ChipColor = "success" | "primary" | "info" | "warning" | "error" | "secondary" | "default";

export const getStatusColor = (status: string): ChipColor => {
  const statusLower = status?.toLowerCase() || "";
  if (statusLower.includes("delivered")) return "success";
  if (statusLower.includes("shipped")) return "primary";
  if (statusLower.includes("ordered")) return "success";
  if (statusLower.includes("processing")) return "warning";
  if (statusLower.includes("purchased")) return "info";
  if (statusLower.includes("pending")) return "warning";
  if (statusLower.includes("cancelled") || statusLower.includes("canceled")) return "error";
  if (statusLower.includes("refund")) return "error";
  if (statusLower.includes("hold")) return "warning";
  if (statusLower.includes("placed")) return "default";
  return "default";
};
